import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { DocId } from 'records/Doc';
import { Space } from 'records/Space';
import { getSpaces } from 'services/spaceService';

export interface SpaceActions {
  getSpaces: (
    actionParams: AppStateActionParams,
    documentId: DocId
  ) => Promise<AppState>;
}

const spaceActions: SpaceActions = {
  getSpaces: async (
    { state }: AppStateActionParams,
    documentId: DocId
  ): Promise<AppState> => {
    const spaces = await getSpaces(documentId);

    const g = spaces
      .groupBy((s) => s.pageid)
      .map((spArr) => {
        return spArr.reduce(
          (acc, ss) => acc.set(ss.spaceid, ss),
          Immutable.OrderedMap<string, Space>()
        );
      })
      .toOrderedMap();

    return state().set('spaces', g);
  },
};

export default spaceActions;
